import React, { Component } from 'react';
import '../assets/css/Login/redeem.css'
import { APIExpress } from '../api/redeem'
import { Form, Input, Button,Toast, Space, Divider} from 'antd-mobile'
import img from '../assets/image/banner2.jpg'

/** 样式 */
// var loginTopBg = {height: '300px',background:'#3677ea'};

class Wuliu extends Component {
    constructor(props) {
        super(props)
        this.state = { 
            express_number: "", 
            phone:'',
        }
    }
    setPhone(value) {
        this.setState({
            phone: value
        })
    }

    Express() {
        //发起请求
        APIExpress({
            phone: this.state.phone,
        }).then((res) => {
            if(res.data.code===0){
                this.setState({express_number:res.data.data})
                Toast.show({
                    icon: 'success',
                    content: '查询成功',
                })
                // this.props.history.push({ pathname: '/index/home' })
            }else{
                Toast.show({
                    icon: 'fail',
                    content: res.msg,
                })
            }
            
        })
    }

    nextTo(){
        this.props.history.push({ pathname: '/index/home' })
    }
   
    render() {
        return (
            <div className='login'>
                <img src={img} width={'100%'}/>
               
                <Form  onFinish={() => { this.Express() }}
                    footer={
                        <Button block type='submit' color='primary' size='large'>
                            单号查询
                        </Button>
                 
                    }
                >
                    <>
                        <Form.Item
                            name='phone'
                            label='手机号'
                            rules={[{ required: true, message: '请填写手机号' }]}
                        >
                            <Input placeholder='请输入手机号' onChange={(e) => {
                                this.setPhone(e)
                            }} />
                        </Form.Item>
                    </>
                </Form>
                <Divider />
                <Space>
                    <span className='text20'>物流单号：</span>
                    <span className='text20'>{this.state.express_number}</span>
                </Space>
            </div>
        );
    }
}

export default Wuliu;